import { useState } from "react";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Tooltip from "@mui/material/Tooltip";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import HistoryIcon from "@mui/icons-material/History";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import ReplayIcon from "@mui/icons-material/Replay";
import SwapHorizIcon from "@mui/icons-material/SwapHoriz";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import { AdvanceRow, rowActionRules } from "./columns";

export type RowActionsMenuProps = {
  row: AdvanceRow;
  canWrite: boolean;
  onChangeStatus: (row: AdvanceRow) => void;
  onShowDutys: (row: AdvanceRow) => void;
  /** Histórico do pacote (só leitura, visível para Leitura também). Sem ele, o item não aparece. */
  onShowHistory?: (row: AdvanceRow) => void;
  onGenerateContract: (row: AdvanceRow) => void;
  onCancel: (row: AdvanceRow) => void;
  /** F1b: só com a chave packageExpiration; sem ele o item não aparece. */
  onReopen?: (row: AdvanceRow) => void;
};

export default function RowActionsMenu({ row, canWrite, onChangeStatus, onShowDutys, onShowHistory, onGenerateContract, onCancel, onReopen }: RowActionsMenuProps) {
  const [anchor, setAnchor] = useState<HTMLElement | null>(null);
  const rules = rowActionRules(row, canWrite);
  const run = (fn: (r: AdvanceRow) => void) => () => {
    setAnchor(null);
    fn(row);
  };
  return (
    <>
      <Tooltip title="Ações">
        <IconButton aria-label={`Ações do pacote #${row.id}`} aria-haspopup="menu" onClick={(e) => setAnchor(e.currentTarget)} sx={{ width: 40, height: 40 }}>
          <MoreVertIcon />
        </IconButton>
      </Tooltip>
      <Menu anchorEl={anchor} open={Boolean(anchor)} onClose={() => setAnchor(null)} anchorOrigin={{ vertical: "bottom", horizontal: "right" }} transformOrigin={{ vertical: "top", horizontal: "right" }} PaperProps={{ sx: { minWidth: 230 } }}>
        {rules.changeStatus.visible && (
          <MenuItem disabled={rules.changeStatus.disabled} onClick={run(onChangeStatus)}>
            <ListItemIcon><SwapHorizIcon fontSize="small" /></ListItemIcon>
            <ListItemText primary="Trocar Status" secondary={rules.changeStatus.hint} />
          </MenuItem>
        )}
        <MenuItem onClick={run(onShowDutys)}>
          <ListItemIcon><VisibilityOutlinedIcon fontSize="small" /></ListItemIcon>
          <ListItemText primary="Ver Plantões" />
        </MenuItem>
        {onShowHistory && (
          <MenuItem onClick={run(onShowHistory)}>
            <ListItemIcon><HistoryIcon fontSize="small" /></ListItemIcon>
            <ListItemText primary="Histórico" />
          </MenuItem>
        )}
        {rules.contract.visible && (
          <MenuItem disabled={rules.contract.disabled} onClick={run(onGenerateContract)}>
            <ListItemIcon><DescriptionOutlinedIcon fontSize="small" /></ListItemIcon>
            <ListItemText primary="Gerar contrato" secondary={rules.contract.hint} />
          </MenuItem>
        )}
        {onReopen && rules.reopen.visible && (
          <MenuItem disabled={rules.reopen.disabled} onClick={run(onReopen)}>
            <ListItemIcon><ReplayIcon fontSize="small" /></ListItemIcon>
            <ListItemText primary="Reabrir" secondary={rules.reopen.hint} />
          </MenuItem>
        )}
        {rules.cancel.visible && <Divider />}
        {rules.cancel.visible && (
          <MenuItem disabled={rules.cancel.disabled} onClick={run(onCancel)} sx={{ color: "error.main" }}>
            <ListItemIcon><CancelOutlinedIcon fontSize="small" color="error" /></ListItemIcon>
            <ListItemText primary="Cancelar" />
          </MenuItem>
        )}
      </Menu>
    </>
  );
}
